<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">
			<label>{{ usuarioLogado }}</label>	
			<button class="p-link" @click="meusDados" title="Meus Dados">
				<span class="layout-topbar-item-text">Meus Dados</span>
				<span class="layout-topbar-icon pi pi-user"></span>
			</button>
			<button class="p-link" title="Noticias" @click="noticias">
				<span class="layout-topbar-item-text">Noticias</span>
				<span class="layout-topbar-icon pi pi-calendar"></span>
				<span class="layout-topbar-badge" v-if="qtdNoticias">{{ qtdNoticias }}</span>
			</button>
			<button class="p-link" title="Sistema" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" v-if="itens.length > 0">
				<span class="layout-topbar-item-text">Sistema</span>
				<span class="layout-topbar-icon pi pi-cog"></span>
			</button>
			<button class="p-link" @click="logout" title="Sair">
				<span class="layout-topbar-item-text">Sair</span>
				<span class="layout-topbar-icon pi pi-power-off"></span>
			</button>
		</div>
		<Menu id="overlay_menu" ref="menu" :model="itens" :popup="true" appendTo="body" style="width: 220px"/>		
	</div>
</template>

<script>
import MensagemService from '@/service/MensagemService.js';
import { mapActions, mapGetters } from 'vuex';

export default {
	mensagemService: null,
	props: ['usuarioLogado'],
	data() {
		return {
			itens: [],
			qtdNoticias: ''
		}
	},
    methods: {
		...mapActions('sessao', ['limparSessao']),
		...mapActions('funcionario', ['limparDadosFuncionario']),
		...mapActions('contorlePonto', ['limparRefMarcacoesFuncionario']),
		...mapGetters('sessao', ['getPermissoes']), 
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
		},
		logout() {
			this.limparDadosFuncionario();
			this.limparRefMarcacoesFuncionario();
			this.limparSessao();			
			this.$router.push('/login');
		},
		meusDados() {
			this.$router.push('/conta/meus-dados');
		},
		noticias() {
			this.$router.push('/sistema/noticias');
		},
		toggle(event) {			
            this.$refs.menu.toggle(event);
		},
		validarPermissoes() {
			let permissoes = this.getPermissoes();
			let itensMenu = [
				{label: 'Usuários', icon: 'pi pi-user', to: '/sistema/usuarios', permissao: 2}, 
				{label: 'Perfis e Permissões', icon: 'pi pi-exclamation-circle', to: '/sistema/perfis-permissoes', permissao: 7},
				{label: 'Logs de Operações', icon: 'pi pi-align-center', to: '/sistema/logs-operacoes', permissao: 12},				
				{label: 'Políticas de Privacidade', icon: 'pi pi-file', to: '/sistema/politica-privacidade', permissao: 12},
				/* {label: 'Manual', icon: 'pi pi-cloud-download', to: '/sistema/manual', permissao: 0}, */
				{label: 'ATTR', icon: 'pi pi-cloud-download', permissao: 0, command: () => {this.carregarLink('https://drive.google.com/file/d/1tIj_KXW7P5eIfbyTzq5dofR5vfa1Rsq_/view')}},
				{label: 'Suporte', icon: 'pi pi-ticket', permissao: 0, command: () => {this.carregarLink('https://suporteinfokings.vhdesk.com.br/')}},
				{label: 'Autorização de Suporte', icon: 'pi pi-thumbs-up', to: '/sistema/autorizacao-suporte', permissao: 0},
				{label: 'Sobre o Sistema', icon: 'pi pi-thumbs-up', to: '/sistema/sobre', permissao: 0},
			];
			let menuFiltrado = [];
			itensMenu.forEach(menu => {
				if(permissoes.includes(menu.permissao)) {
					menuFiltrado.push(menu);
				}
			});
			this.itens = menuFiltrado;
		},
		listarNoticias() {
			this.mensagemService.quantidadeDoDia()
			.then(resp => {				
				this.qtdNoticias = resp.data.quantidade == '0' ? '' : resp.data.quantidade;
			})
			.catch(erro => {
				console.log(erro)
			}); 
		},
		carregarLink(link) {			
			window.open(link, '_blank');
		}
	},
	created() {
		this.validarPermissoes();
		this.mensagemService = new MensagemService();
		setTimeout(() => {
			this.listarNoticias();
		}, 2000);
	},
}
</script>